import React from 'react';

import { FormattedMessage } from '../../../../util/reactIntl';
import { useColorScheme } from '../../../../context/colorSchemeContext';
import {
  MOBILE_SEARCH_QUICK_TAGS,
  buildQuickTagSearch,
  quickTagIconSrc,
} from '../../../../config/r2rMobileSearchQuickTags';

import { NamedLink } from '../../../../components';

import css from './MobileSearchQuickTags.module.css';

/**
 * Curated category shortcuts for the mobile search overlay.
 *
 * @component
 * @returns {JSX.Element}
 */
const MobileSearchQuickTags = () => {
  const { colorScheme } = useColorScheme();

  return (
    <section className={css.root} aria-labelledby="mobile-search-quick-tags-heading">
      <h2 id="mobile-search-quick-tags-heading" className={css.heading}>
        <FormattedMessage id="MobileSearchQuickTags.heading" />
      </h2>
      <ul className={css.grid}>
        {MOBILE_SEARCH_QUICK_TAGS.map(tag => (
          <li key={tag.id} className={css.cell}>
            <NamedLink
              name="SearchPage"
              to={{ search: buildQuickTagSearch(tag) }}
              className={css.tag}
            >
              <img
                className={css.icon}
                src={quickTagIconSrc(tag, colorScheme)}
                alt=""
                width="314"
                height="314"
              />
              <span className={css.label}>
                <FormattedMessage id={tag.labelId} />
              </span>
            </NamedLink>
          </li>
        ))}
      </ul>
    </section>
  );
};

export default MobileSearchQuickTags;
